import { cn } from "@/lib/utils";
import { labelLook } from "@/components/emc/status";
import type { LabelDomain } from "@/components/emc/status";

/** A value that is not a state — an exclusion's reason, a signal's source —
 * in Hungarian, as plain text (the pill is for states only). A value the
 * table does not know is shown as it came, in grey, so a new enum value on the
 * API is visible rather than silently translated into nothing. The wire value
 * is on hover either way: it is what the logs say. */
export function EnumText({
  domain,
  value,
  className,
}: {
  domain: LabelDomain;
  value: string;
  className?: string;
}) {
  const look = labelLook(domain, value);
  return (
    <span
      data-slot="enum-text"
      title={value}
      className={cn(!look.known && "data-mono text-muted-foreground", className)}
    >
      {look.label}
    </span>
  );
}
